import React from 'react';
import ReactDOM from 'react-dom';
import Rollbar from 'rollbar';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import './styles/scss-utils/main.scss';
// import './styles/main.less';
// import * as serviceWorker from './serviceWorker';
import store from 'Src/store';
import Segment from 'Components/Segment';
import Version from 'Src/pages/Version';

new Rollbar({
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: { environment: 'onboarding' },
});

ReactDOM.render(
  <Provider store={store}>
    <Segment />
    <Router>
      <Route
        exact
        path="/"
      >
        <Redirect
          to={{
            pathname: '/v1',
          }}
        />
      </Route>
      <Route
        path="/:version"
        component={Version}
      />

    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
